import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalComponent } from '../../global/global.component';
import { forgotpasswordHTTPService } from './forgotpassword.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { resetBO } from './forgotpassword.model';
import { Subject } from 'rxjs';
import { GeneralService } from 'src/app/service/general.service';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss']
})
export class ForgotpasswordComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  reset: resetBO = new resetBO();
  uname: string = "";
  email: string = "";
  type: string = " ";
  agencycode: string = "";
  forgotLoginForm: FormGroup;
  submitted: boolean = false;
  loading: boolean = false;
  IsButtonDisable: boolean = false;

  constructor(private formBuilder: FormBuilder, public router: Router, public global: GlobalComponent,
    public httpService: forgotpasswordHTTPService, public toastrService: ToastrService, public general: GeneralService) {
    this.forgotLoginForm = this.formBuilder.group({
      email: ['', Validators.required],
      agencycode: ['', Validators.required],
    });
  }

  ngOnInit(): void {
  }

  get forgotLogin() {
    return this.forgotLoginForm.controls;
  }


  forgotpasswordlogin() {
    this.global.OnboardingLoginType = "agencyLogin";
    let OnboardUserType = localStorage.getItem("OnboardingLoginType");
  }

  forgotpassword(email, agencycode) {
    this.IsButtonDisable = true;
    let params = new URLSearchParams();
    let type = "Admin";
    params.append("Type", type);
    params.append("Email", email);
    params.append("AgencyCode", agencycode);
    this.httpService.resetPassword(params).subscribe((data: any) => {
      this.IsButtonDisable = false;
      if (data) {
        this.toastrService.success('Temporary password has been sent to your respective mail id',
          'Temporary password sent successfully'), 8000;

      }
    }, (err: any) => {
      this.IsButtonDisable = false;
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }

  close() {
    this.router.navigateByUrl('/login')
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
